<template>
    <vue-table-card title="Course Faculty" :show-search-box="false" :fields="fields"
                    :url="listUrl" :per-page="10" ref="table" :extra-params="{course: id}">
        <template #buttons>
            <btn color="success" icon="fa fa-plus" size="sm" @click="$refs.addModal.show()" text="Add"/>
        </template>

        <template #actions="{rowData}">
            <div class="btn-group-tight">
                <btn size="xs" text="View" @click="setEdit(rowData)"/>
                <delete-btn v-if="!checkIfPublished" @click="setDelete(rowData)"/>
            </div>
        </template>

        <template #footer>
            <modal title="Course Faculty" ref="addModal" width="40r" header-color="primary" no-close-on-backdrop>
                <add-course-faculty @success="formSuccess" :course="id" :location="location"/>
            </modal>

            <modal title="Course Faculty" ref="editModal" width="40r" header-color="primary" no-close-on-backdrop>
                <edit-course-faculty :checkIfPublished="checkIfPublished" :initial-data="editingItem" :course="id"
                                     :location="location" @success="formSuccess"/>
            </modal>

            <delete-modal ref="deleteModal" :url="deleteUrl" :params="deletingItem" @response="deleteComplete">
                <p>You are about to delete the item <b v-html="deletingItem && deletingItem.name"></b>. Are you sure ?
                </p>

                <template #loading>
                    <loading-animation/>
                    Please wait while we delete <b v-html="deletingItem && deletingItem.name"></b>.
                </template>
            </delete-modal>
        </template>

    </vue-table-card>
</template>

<script>
import urls from '../../../../data/urls';
import AddCourseFaculty from './AddCourseFaculty';
import EditCourseFaculty from './EditCourseFaculty';

export default {
    name: 'CourseFaculty',
    props: {
        checkIfPublished: { type: Boolean, default: false },
        location: { type: String }
    },
    components: { EditCourseFaculty, AddCourseFaculty },
    data () {
        return {
            id: this.$route.params.id,
            listUrl: urls.admin.course.detailsUrl.faculty.list,
            addUrl: urls.admin.course.detailsUrl.faculty.addEdit,
            deleteUrl: urls.admin.course.detailsUrl.faculty.delete,
            editingItem: null,
            deletingItem: null,
            fields: [
                {
                    name: 'name',
                    sortField: 'name',
                    title: 'Name'
                },
                {
                    name: 'designation',
                    sortField: 'designation',
                    title: 'Designation'
                },
                {
                    name: 'location.location',
                    sortField: 'location.location',
                    title: 'Location'
                },
                {
                    name: '__slot:actions',
                    titleClass: 'center aligned text-right',
                    dataClass: 'aligned text-right'
                }
            ]
        };
    },
    methods: {
        viewFile (file) {
            window.open(file);
        },
        formSuccess () {
            const refs = this.$refs;
            refs.addModal.close();
            refs.editModal.close();
            refs.table.refreshTable();

            this.editingItem = null;
        },

        setEdit (item) {
            this.editingItem = { ...item };
            this.editingItem.course = this.$route.params.id;
            this.editingItem.location = this.editingItem.location.id;
            this.$refs.editModal.show();
        },

        setDelete (item) {
            this.deletingItem = { ...item };
            this.$refs.deleteModal.show();
        },

        deleteComplete (response) {
            this.deletingItem = null;
            this.$refs.deleteModal.close();
            this.$notify('Deleted Successfully', 'Success', {
                type: 'success'
            });
            this.$refs.table.refreshTable();
        }
    }
};
</script>
